import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {IUserPoi} from "../types/IUserPoi";

export interface IPendingSinglePoiState {
    poi: IUserPoi | null;
}

const initialState: IPendingSinglePoiState = {
    poi: null
};

export const pendingSinglePoiSlice = createSlice({
    name: "pendingSinglePoi",
    initialState,
    reducers: {
        setPendingSinglePoi: (state, action: PayloadAction<IUserPoi>) => {
            state.poi = action.payload;
        },
        clearPendingSinglePoi: (state) => {
            state.poi = null;
        }
    }
});

export const {setPendingSinglePoi, clearPendingSinglePoi} = pendingSinglePoiSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {IUserPoi} from "../types/IUserPoi";

export interface IPendingSinglePoiState {
    poi: IUserPoi | null;
}

const initialState: IPendingSinglePoiState = {
    poi: null
};

export const pendingSinglePoiSlice = createSlice({
    name: "pendingSinglePoi",
    initialState,
    reducers: {
        setPendingSinglePoi: (state, action: PayloadAction<IUserPoi>) => {
            state.poi = action.payload;
        },
        clearPendingSinglePoi: (state) => {
            state.poi = null;
        }
    }
});

export const {setPendingSinglePoi, clearPendingSinglePoi} = pendingSinglePoiSlice.actions;
